
import { mapGetters } from 'vuex'
import pluralize from 'pluralize'
import FilterTag from './FilterTag'
import { generateRandomString } from '~/ZenOne-StoryBook/helpers/random'
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'

export default {
  name: 'FilterTags',
  components: { FilterTag },
  props: {
    isCatalog: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      generateRandomString,
    }
  },
  computed: {
    ...mapGetters({
      catalogFilters: 'catalog/filters',
      catalogFilterTags: 'catalog/filterTags',
      inventoryFilters: 'inventory/filters',
      inventoryFilterTags: 'inventory/filterTags',
    }),
    filterTags() {
      return this.isCatalog ? this.catalogFilterTags : this.inventoryFilterTags
    },
    hasSearchTerm() {
      return this.isCatalog ? null : this.inventoryFilters?.search?.length > 0
    },
    filters() {
      return this.isCatalog ? this.catalogFilters : this.inventoryFilters
    },
    tags() {
      return this.filterTags
    },
    hasTags() {
      return isArrayWithLength(this.tags)
    },
    counterText() {
      const { totalCount = 0 } = this
      return `${totalCount} ${pluralize('item', this.totalCount)}`
    },
  },
  methods: {
    onRemoveFilter({ tag = {} }) {
      let filters = { ...this.filters }
      const filterName = tag.filterName
      const value = filters[filterName]

      if (isArrayWithLength(value)) {
        const set = new Set([...value])
        set.delete(parseInt(tag?.id))
        filters = {
          ...filters,
          [filterName]: [...set],
        }
      } else if (typeof value === 'boolean') {
        filters[filterName] = false
      } else {
        delete filters[filterName]
      }
      this.$emit('on-save-filters', { filters })
    },
  },
}
